var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path8, _path9, _path10, _circle8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGauth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.961,
    cy: 30.963,
    r: 30,
    fill: "#616161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.086 50.053c-10.589 0-19.17-8.545-19.17-19.09s8.581-19.09 19.17-19.09a19.157 19.157 0 0 1 13.555 5.591l7.746-7.714A30.096 30.096 0 0 0 31.086.963C14.448.963.961 14.394.961 30.963c0 16.569 13.487 30 30.125 30a30.11 30.11 0 0 0 21.303-8.785l-7.746-7.714a19.175 19.175 0 0 1-13.557 5.59z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.753 30.188h-9.671c0-5.214-4.33-9.445-9.671-9.445-5.341 0-9.669 4.229-9.669 9.445 0 2.54 1.029 4.844 2.701 6.544l-.007.008L35.41 48.432l.003.002c8.258-2.152 14.341-9.505 14.341-18.247z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.961 31.292H50.055c0 8.673-6.005 15.968-14.149 18.104l8.422 8.27c9.86-4.825 16.633-14.822 16.633-26.374z",
    fill: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.96 59.966c-16.51 0-29.902-13.118-29.997-29.333l-.002.169c0 16.293 13.431 29.501 30 29.501 16.569 0 30-13.208 30-29.501l-.002-.17c-.095 16.216-13.49 29.334-29.998 29.334z",
    fill: "#212121",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m35.25 48.832.273.262c8.21-2.233 14.232-9.499 14.232-18.125v-.336c0 8.719-6.156 16.052-14.505 18.199z",
    fill: "#fff",
    fillOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.972 27.995H30.693c-1.49 0-2.697 1.18-2.697 2.637s1.208 2.638 2.697 2.638H54.97c1.49 0 2.697-1.18 2.697-2.638.003-1.456-1.205-2.637-2.694-2.637z",
    fill: "#9E9E9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.972 27.995H30.693c-1.49 0-2.697 1.18-2.697 2.637s1.208 2.638 2.697 2.638H54.97c1.49 0 2.697-1.18 2.697-2.638.003-1.456-1.205-2.637-2.694-2.637z",
    fill: "#BDBDBD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.416,
    cy: 30.963,
    fill: "#BDBDBD",
    r: 2.045
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.963,
    cy: 6.416,
    fill: "#BDBDBD",
    r: 2.045
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.963,
    cy: 55.506,
    r: 2.045,
    fill: "#BDBDBD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.576,
    cy: 13.606,
    fill: "#BDBDBD",
    r: 2.045
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.576,
    cy: 48.349,
    fill: "#BDBDBD",
    r: 2.045
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.35,
    cy: 48.349,
    r: 2.045,
    fill: "#757575"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.961 28.576h24.544a2.722 2.722 0 0 1 2.717 2.558c.003-.058.01-.114.01-.172a2.727 2.727 0 0 0-2.727-2.727H30.961a2.727 2.727 0 0 0-2.727 2.727c0 .058.003.114.01.172a2.72 2.72 0 0 1 2.717-2.558z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.222 31.132a2.73 2.73 0 0 1-2.717 2.558H30.961a2.723 2.723 0 0 1-2.717-2.558c-.007.058-.01.113-.01.17a2.727 2.727 0 0 0 2.727 2.726h24.544a2.727 2.727 0 0 0 2.727-2.727c0-.055-.002-.111-.01-.17z",
    fill: "#212121",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.961 12.213c5.27 0 10.042 2.137 13.5 5.591l7.88-7.885-.17-.172-7.71 7.714a19.038 19.038 0 0 0-13.5-5.591c-10.544 0-19.09 8.545-19.09 19.09l.002.171c.092-10.465 8.602-18.918 19.088-18.918z",
    fill: "#212121",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.961,
    cy: 30.963,
    r: 30,
    fill: "url(#kpfwipe5va)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "kpfwipe5va",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.759 9.692) scale(59.8964)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGauth);
export default __webpack_public_path__ + "static/media/ic-gauth.a7340b67bfd7b12f15f4dd14e6bd9764.svg";
export { ForwardRef as ReactComponent };